import axios from '@/utils/axiosInstance';

export type ApplicationClassCategory = "np" | "dsu";

export interface ApplicationClass {
  id: number;
  category: ApplicationClassCategory;
  code: string;
  title: string;
  value: string;
  program: string | null;
  semester: string | null;
  meta: string | null;
  sort_order?: number;
  is_active?: boolean;
}

export interface ApplicationClassInput {
  category: ApplicationClassCategory;
  code: string;
  title: string;
  value: string;
  program?: string | null;
  semester?: string | null;
  meta?: string | null;
  is_active?: boolean;
}

// Public: active classes for a category (used by the NP/DSU application pages).
export async function getApplicationClasses(category: ApplicationClassCategory) {
  const response = await axios.get(`/application-classes`, { params: { category } });
  return (response.data?.data ?? []) as ApplicationClass[];
}

// Admin: all classes (active + inactive) for management.
export async function getAdminApplicationClasses(category: ApplicationClassCategory) {
  const response = await axios.get(`/admin/application-classes`, { params: { category } });
  return (response.data?.data ?? []) as ApplicationClass[];
}

export async function createApplicationClass(payload: ApplicationClassInput) {
  const response = await axios.post(`/admin/application-classes`, payload);
  return response.data?.data as ApplicationClass;
}

export async function updateApplicationClass(id: number, payload: Partial<ApplicationClassInput>) {
  const response = await axios.put(`/admin/application-classes/${id}`, payload);
  return response.data?.data as ApplicationClass;
}

export async function deleteApplicationClass(id: number) {
  const response = await axios.delete(`/admin/application-classes/${id}`);
  return response.data;
}
